import e, { useState as t } from "react";
import n from "../../../../../node_modules/classnames/index.js";
import { SidebarItem as r } from "./SidebarItem.js";
import { Icon as a } from "../../../general/Icon/Icon.js";
function l(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var o = function o(i) {
  var m,
    s = function (e) {
      if (Array.isArray(e)) return e;
    }(m = t(!1)) || function (e, t) {
      var n,
        r,
        a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != a) {
        var l = [],
          o = !0,
          i = !1;
        try {
          for (a = a.call(e); !(o = (n = a.next()).done) && (l.push(n.value), !t || l.length !== t); o = !0);
        } catch (e) {
          i = !0, r = e;
        } finally {
          try {
            o || null == a.return || a.return();
          } finally {
            if (i) throw r;
          }
        }
        return l;
      }
    }(m, 2) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return l(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        if ("Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, t);
      }
    }(m, 2) || function () {
      throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(),
    c = s[0],
    u = s[1],
    f = i.item,
    p = i.onItemClick,
    y = i.isCollapsed,
    d = i.isLinkActive,
    v = i.onExpand,
    b = i.template,
    g = i.templateClasses,
    h = f.title,
    E = f.className,
    C = f["icon-name"],
    x = f["submenu-items"],
    N = function N(e) {
      var t = !0,
        n = !1,
        r = void 0;
      try {
        for (var a, l = e[Symbol.iterator](); !(t = (a = l.next()).done); t = !0) {
          var o = a.value;
          if (d(o) || N(o["submenu-items"] || [])) return !0;
        }
      } catch (e) {
        n = !0, r = e;
      } finally {
        try {
          t || null == l.return || l.return();
        } finally {
          if (n) throw r;
        }
      }
      return !1;
    };
  return e.createElement("li", {
    className: n("submenu-container", c && "open")
  }, e.createElement("div", {
    onClick: function onClick() {
      v(), y || u(!c);
    },
    className: n("submenu-toggle", (y || !c) && N(x) && "active")
  }, e.createElement("div", {
    className: g.tooltipTargetClass
  }), e.createElement(a, {
    regular: !0,
    className: E,
    name: C,
    fw: !0
  }), e.createElement("span", {
    className: g.tooltipTextClass
  }, h), c ? e.createElement(a, {
    name: "angle-up",
    className: "collapse-icon",
    regular: !0
  }) : e.createElement(a, {
    name: "angle-down",
    className: "expand-icon",
    regular: !0
  })), e.createElement("ul", {
    className: "submenu",
    style: {
      maxHeight: c ? 32 * x.length : 0
    }
  }, x.map(function (t, n) {
    return "submenu" === t.type ? e.createElement(o, {
      key: n,
      item: t,
      template: b,
      templateClasses: g,
      onItemClick: p,
      isLinkActive: d,
      onExpand: v,
      isCollapsed: y
    }) : e.createElement(r, {
      key: n,
      item: t,
      template: b,
      templateClasses: g,
      onClick: p(t, n),
      active: d(t)
    });
  })));
};
export { o as Submenu };